@if (loading()) {
  <div class="eventq-detail-field eventq-detail-field--loading" aria-hidden="true">
    <div class="eventq-detail-field__skeleton">
      <span class="eventq-detail-field__skeleton-icon"></span>
      <div class="eventq-detail-field__skeleton-copy">
        <span class="eventq-detail-field__skeleton-line eventq-detail-field__skeleton-line--label"></span>
        <span class="eventq-detail-field__skeleton-line eventq-detail-field__skeleton-line--value"></span>
      </div>
    </div>
  </div>
} @else {
  <div class="eventq-detail-field">
    <span class="eventq-detail-field__icon" aria-hidden="true">
      <img [src]="iconSrc() | prefixUrl" alt="" width="16" height="16" />
    </span>
    <div class="eventq-detail-field__copy">
      <p class="eventq-detail-field__label">{{ label() }}</p>
      <p class="eventq-detail-field__value">{{ value() }}</p>
    </div>
  </div>
}
